export const getPlaybackMemory = (roomId) => {
  try {
    const memoryData = localStorage.getItem('playbackMemoryArray');
    if (!memoryData) return null;
    
    const memories = JSON.parse(memoryData);
    // 查找指定roomId的最新记录
    const memory = memories.find(m => m.roomId === roomId);
    return memory || null;
  } catch (error) {
    console.error('获取播放记忆失败:', error);
    return null;
  }
};

export const savePlaybackPosition = (roomId, position) => {
  try {
    const memoryData = localStorage.getItem('playbackMemoryArray');
    let memories = memoryData ? JSON.parse(memoryData) : [];
    
    // 查找
    const memory = memories.find(m => m.roomId === roomId);
    if (memory && memory.position === position) {
        return;
    }

    // 移除同roomId的旧记录
    memories = memories.filter(m => m.roomId !== roomId);
    
    // 添加新记录
    memories.push({
      roomId,
      position,
      timestamp: Date.now()
    });
    
    // 如果超过5个记录，删除最早的记录
    if (memories.length > 5) {
      // 找到时间戳最小的记录（最早的）
      let oldestIndex = 0;
      for (let i = 1; i < memories.length; i++) {
        if (memories[i].timestamp < memories[oldestIndex].timestamp) {
          oldestIndex = i;
        }
      }
      
      // 删除最早的记录
      memories.splice(oldestIndex, 1);
    }
    
    // 保存回localStorage
    localStorage.setItem('playbackMemoryArray', JSON.stringify(memories));
  } catch (error) {
    console.error('保存播放位置失败:', error);
  }
};